export const WSAvatar = ({
  userName,
  src,
  size,
}: {
  userName: string;
  src?: string;
  size: "sm" | "md" | "lg" | "xl";
}) => {
  const userInitials = userName
    ? userName
        .split(" ")
        .map((n) => n[0])
        .join("")
    : "";

  return (
    <>
      {src && src != "data:image/png;base64," ? (
        // oxlint-disable-next-line nextjs/no-img-element
        <img
          className={`
        ${size == "sm" ? "h-8 w-8" : ""}
        ${size == "md" ? "h-10 w-10" : ""}
        ${size == "lg" ? "h-12 w-12" : ""}
        ${size == "xl" ? "h-20 w-20" : ""}

        rounded-full`}
          src={src}
          alt=""
        />
      ) : (
        <span
          className={`
        inline-flex items-center justify-center 
        ${size == "sm" ? "h-8 w-8 text-sm" : ""}
        ${size == "md" ? "h-10 w-10 text-sm" : ""}
        ${size == "lg" ? "h-12 w-12 text-lg" : ""}
        ${size == "xl" ? "h-20 w-20 text-xl" : ""}
        rounded-full bg-neutral-shortcutBackground`}
        >
          <span className="font-medium leading-none text-neutral-textOnDark">{userInitials}</span>
        </span>
      )}
    </>
  );
};

export default WSAvatar;
